import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchGroup = (params) => {
  return apiBase({
    url: `/cats/groups`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const StoreGroup = (params) => {
  return apiBase({
    url: '/cats/groups',
    method: 'post',
    data: params
  });
};

export const ShowGroup = ({ id }) => {
  return apiBase({
    url: `/cats/groups/${id}`,
    method: 'get'
  });
};

export const UpdateGroup = (params) => {
  return apiBase({
    url: `/cats/groups/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyGroup = ({ id }) => {
  return apiBase({
    url: `/cats/groups/${id}`,
    method: 'delete'
  });
};
